package user.service

import RouteSetting
import org.jooq.PermissionType

object CurrentUserPermission {

    fun canAccess(route: RouteSetting):Boolean{
        val memeberData = AuthService.getUserAuthData()
        val permissions = route.permissions;
        if(memeberData==null){    //没登录不显示菜单
            return false;
        }
        var hasPerm = false;
        if(!permissions.isEmpty()){
            if(memeberData!!.getPermissions().isNullOrEmpty()){
                hasPerm = false;
            }else{
                for (i in 0..permissions.size-1){
                    if(memeberData!!.getPermissions().contains(permissions[i])){
                        hasPerm = true;
                        break;
                    }
                }
            }
        }else{
            hasPerm = true;
        }
        return hasPerm;
    }

    /**
     * todo: 实现真正的权限
     */
    fun hasPerm(permission: PermissionType):Boolean{
        val memeberData = AuthService.getUserAuthData()
        if(memeberData==null){    //没登录
            return false;
        }
        return true;
        /*var hasPerm = false;
        if(memeberData!!.getPermissions().isNullOrEmpty()){
            hasPerm = false;
        }else if(memeberData!!.getPermissions().contains(permission)){
            hasPerm = true;
        }
        return hasPerm;*/
    }


}
